/* eslint-disable import/no-cycle */
import { HStack, Text, Box, Icon } from '@chakra-ui/core';
import React from 'react';
import { MdInfoOutline } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { ScreeningType } from '../formElements/ScreeningType';
import { QuestionRequireResponse } from '../formElements/QuestionRequireResponse';
import { SCREENING_TYPE } from '../../../questionnaireTemplate.enums';
import { QuestionnaireBuilderElementProps } from '../../../questionnaireTemplate.types';
import { QuestionSkipQuestion } from '../formElements/QuestionSkipQuestion';
import { QuestionUploadNumberSelect } from '../formElements/QuestionUploadNumberSelect';

const FILE_TYPE_CONTAINER_PROPS = {
  px: 3,
  py: 1,
  borderRadius: 'md',
  border: '1px solid #AED0FF',
  bg: '#EFF6FF',
} as const;

export const DocumentUpload = React.memo(function DocumentUpload({ elementId }: QuestionnaireBuilderElementProps) {
  const { t } = useTranslation('questionnaireTemplate');

  return (
    <>
      <HStack>
        <Text fontSize="sm">{t('formBuilder.canvas.element.documentUpload.supportedTypeTitle')}</Text>
        <Box m={2} {...FILE_TYPE_CONTAINER_PROPS}>
          <Text color="blue.500" fontSize="xs">
            {t('formBuilder.canvas.element.documentUpload.supportedTypes')}
          </Text>
        </Box>
      </HStack>
      <Box {...FILE_TYPE_CONTAINER_PROPS}>
        <HStack spacing={2}>
          <Icon as={MdInfoOutline} color="#1F3CBA" boxSize={4} />
          <Text fontSize="sm" color="#2339A0">
            {t('formBuilder.canvas.element.validationRules.title')}
          </Text>
        </HStack>
        <Box display="inline-block" lineHeight="2.5rem">
          <Text as="span" fontSize="sm" color="gray.700">
            {t('formBuilder.canvas.element.documentUpload.validationRuleText1')}
          </Text>
          <QuestionUploadNumberSelect elementId={elementId} />
          <Text as="span" fontSize="sm" color="gray.700">
            {t('formBuilder.canvas.element.documentUpload.validationRuleText2')}
          </Text>
        </Box>
      </Box>
      <ScreeningType id={elementId} screeningTypes={[SCREENING_TYPE.NONE, SCREENING_TYPE.REVIEW]} />
      <HStack spacing={4}>
        <QuestionRequireResponse elementId={elementId} />
        <QuestionSkipQuestion elementId={elementId} />
      </HStack>
    </>
  );
});
